import { render, staticRenderFns } from "./SelectMulPro.vue?vue&type=template&id=0d2dcf18&scoped=true"
import script from "./SelectMulPro.vue?vue&type=script&lang=js"
export * from "./SelectMulPro.vue?vue&type=script&lang=js"
import style0 from "./SelectMulPro.vue?vue&type=style&index=0&id=0d2dcf18&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2dcf18",
  null
  
)

export default component.exports